/* @flow */
import GroupProfile from './GroupProfile';
import GroupProfileContainer from './GroupProfileContainer';

import type { Props, GroupProfileType } from './GroupProfile';

export type { Props as GroupProfileProps, GroupProfileType };

export { GroupProfile };
export default GroupProfileContainer;
